import { Button, Typography, withSnackbar, WithSnackbarProps } from '@robocorp/components';
import { Component, Fragment } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { fetchBuildInfo } from '~/queries/useBuildInfoQuery';

type Props = WithTranslation & WithSnackbarProps;

class VersionChecker extends Component<Props> {
  interval: number | null;

  constructor(props: Props) {
    super(props);
    this.interval = null;
  }

  async componentDidMount() {
    if (!import.meta.env.DEV) {
      await this.checkVersion();

      this.interval = window.setInterval(this.checkVersion, 300000);
    } else {
      // eslint-disable-next-line no-console
      console.log('%cVersionChecker is disabled in development environment', 'color: red');
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  showUpdate = () => {
    const { t, addSnackbar } = this.props;

    addSnackbar({
      message: t('updateAvailable'),
      actions: () => (
        <Button variant="secondary" size="small" onClick={this.refreshPage}>
          <Typography>{t('refreshPage')}</Typography>
        </Button>
      ),
      persist: true,
      unique: true,
      variant: 'default',
    });
  };

  checkVersion = async () => {
    try {
      const json = await fetchBuildInfo();

      if (json.buildInfo !== 'LATEST') {
        if (json.buildInfo !== import.meta.env.VITE_BUILD_INFO) {
          this.showUpdate();
        }
      }
    } catch (_err) {
      // Fetching version info failed
    }
  };

  refreshPage = () => {
    document.location.reload();
  };

  render() {
    return <Fragment />;
  }
}

const translated = withTranslation()(VersionChecker);
export default withSnackbar(translated);
